import { Injectable } from '@angular/core';
import { delay, of, type Observable } from 'rxjs';

import type { EmailSendClient, SendEmailRequest, SendEmailResponse } from '../tokens/email-send-client.token';

@Injectable({ providedIn: 'root' })
export class EmailSendMockService implements EmailSendClient {
  send(_payload: SendEmailRequest): Observable<SendEmailResponse> {
    return of({ success: true } satisfies SendEmailResponse).pipe(delay(300));
  }
}
